/**
 * The shared demo account Sales runs demos and records videos from
 * (the Design Inc. team in the `try` realm).
 *
 * Sales and CS jump to this account constantly, so the Galaxy top bar exposes a
 * one-click shortcut to it — see `canJumpToDemoAccount` in `hooks/useFeatureFlags`
 * for the gating and `components/AppBar` for the button. Team, tenant and realm
 * live here so pointing the shortcut at a different account is a one-line change.
 */
export const DEMO_ACCOUNT = {
  teamId: 40,
  tenant: 'try',
  realmId: 'try',
} as const;

/** Top bar label for the {@link DEMO_ACCOUNT} shortcut. */
export const DEMO_ACCOUNT_SHORTCUT_LABEL = 'Jump to Demo';
